module.exports = __webpack_public_path__ + "assets/img/ocs.52e8c09c.png";